import { isValidDecimalNumber, noZeroAfterDecimal } from 'utils/isValidDecimalNumber'

const SCORE_PRECISION = 10

export const isValidIrreplaceabilityScore = (value) => {
  return isValidDecimalNumber(Number(value))
}

export const isWholeNumber = (value) => Number(value) % 1 === 0

export const isValidDecimalWithNoTrailingZero = (value) => noZeroAfterDecimal(value)

export const toCriterionEScore = (value) => Number(Number.parseFloat(value).toFixed(SCORE_PRECISION))

export const isValidYearInput = (value, inputLength) => {
  return new RegExp(`^\\d{0,${inputLength}}$`).test(value)
}

export const isFutureYear = (value) => {
  if (!value) return false
  return Number(value) > new Date().getFullYear()
}

